import React from 'react';
import cls from 'classnames';
import { DefaultTheme } from 'react-jss';
import AircraftSpinnerIcon from '@core-ui/icons/AircraftSpinnerIcon';
import CircleSpinnerIcon from '@core-ui/icons/CircleSpinnerIcon';

import useStyles from './styles';
import { COLOURS, ICON_SIZE } from '@core-ui/styles';

interface ILoaderProps {
  className?: string;
  size?: number;
  cell?: boolean;
  disablePadding?: boolean;
  mode?: 'aircraft' | 'circle';
  color?: string; // hex for circle
}

const Loader: React.FC<ILoaderProps & DefaultTheme> = (props) => {
  const {
    size = 110,
    mode = 'aircraft',
    className,
    color = COLOURS.OWNER,
    cell,
    disablePadding,
  } = props;

  const classes = useStyles();
  const iconSize = cell ? ICON_SIZE.MD : size;

  return (
    <div className={cls(classes.root, className)} style={{ padding: disablePadding ? 0 : 20 }}>
      <div className={classes.loader} style={{ width: size, height: size }}>
        {mode === 'aircraft' ? (
          <AircraftSpinnerIcon style={{ width: iconSize, height: iconSize }} />
        ) : (
          <CircleSpinnerIcon
            style={{ width: iconSize, height: iconSize }}
            color={color}
          />
        )}
      </div>
    </div>
  );
};

export { Loader, ILoaderProps };
